export default __webpack_public_path__ + "static/media/file_icon_blank.2fd0315d.png";